import * as React from 'react';
import { getIntents } from '../../intent';
import { addIntentsToProps } from './props';
import { onRender } from '../intentTypes';
import { DYNAMIC_TOKEN_PREFIX } from '../css/core/constants';
import { useIsomorphicLayoutEffect } from '../../util';
const renderIntents = [];
export function addRenderIntent(intentType, callback) {
    renderIntents.push([
        intentType,
        callback
    ]);
}
addRenderIntent(onRender, (onRenders, props)=>{
    if (!onRenders) {
        return;
    }
    onRenders.forEach((callback)=>{
        addIntentsToProps(props, callback(props));
    });
});
// Store NODE_ENV check in a constant because some tests override NODE_ENV.
// The check for a custom property will not work in a test environment because
// jsdom does not support inserting CSS custom properties.
const isDevMode = process.env.NODE_ENV === 'development';
let hasThrownDevError = false;
export function runRenderIntents(props) {
    for(let i = 0; i < renderIntents.length; i++){
        const [intentType, callback] = renderIntents[i];
        const intents = getIntents(intentType, props);
        addIntentsToProps(props, callback(intents, props));
    }
    if (isDevMode) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const ref = React.useRef(null);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useIsomorphicLayoutEffect(()=>{
            if (!hasThrownDevError && (ref === null || ref === void 0 ? void 0 : ref.current) && ref.current.isConnected && !getComputedStyle(ref.current).getPropertyValue(`--${DYNAMIC_TOKEN_PREFIX}hue-gray0`)) {
                hasThrownDevError = true;
                throw new Error(`Element ${ref.current.outerHTML} was rendered without Sail Next style values being present. It requires a Sail Next theme provider above it, or adoptedStyleSheets to be set before it renders.`);
            }
        }, []);
        addIntentsToProps(props, [
            {
                ref
            }
        ]);
    }
}

//# sourceMappingURL=render.js.map